"use client";

import { motion } from "framer-motion";
import { Workflow, Brain, BarChart3 } from "lucide-react";
const features = [{
  icon: Workflow,
  title: "Guided Workflow",
  description: "Step-by-step guidance through complex strategic analysis processes. Our intelligent workflow adapts to your business context and ensures nothing is missed.",
  color: "from-primary to-primary-dark"
}, {
  icon: Brain,
  title: "AI Strategy Recommendations",
  description: "Advanced AI algorithms analyze your data and market conditions to provide personalized strategic recommendations that drive real business results.",
  color: "from-accent-green to-primary"
}, {
  icon: BarChart3,
  title: "Instant Data Visualization",
  description: "Transform complex datasets into clear, actionable insights with beautiful charts and interactive dashboards that tell your story.",
  color: "from-accent-amber to-accent-green"
}];
export function FeaturesSection() {
  return <section id="features" className="py-20 px-6 bg-white" data-unique-id="237beeed-d3d8-429c-8f72-74971d41bdba" data-file-name="components/features-section.tsx">
      <div className="max-w-7xl mx-auto" data-unique-id="b55399e2-c56b-4ba5-960f-cce572608c52" data-file-name="components/features-section.tsx">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-unique-id="963bd247-a0d0-4104-bc83-bcd7c51af12b" data-file-name="components/features-section.tsx">
          <h2 className="text-4xl font-bold mb-4" data-unique-id="92dbdf11-f4d8-40f2-aa30-331275590e8b" data-file-name="components/features-section.tsx"><span className="editable-text" data-unique-id="330add22-2226-48cd-91da-7e04aed0ff00" data-file-name="components/features-section.tsx">
            Powerful Features for </span><span className="gradient-text" data-unique-id="b8653aa8-5162-4bc6-81b6-3d955212919d" data-file-name="components/features-section.tsx"><span className="editable-text" data-unique-id="d98a9dea-13c5-42e7-8864-2b9704b6d281" data-file-name="components/features-section.tsx">Strategic Success</span></span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto" data-unique-id="2b160653-7160-40f1-9b5e-d58fc99d4d9d" data-file-name="components/features-section.tsx"><span className="editable-text" data-unique-id="fbe4a2dc-d12a-44fb-be30-57e37ecd27f2" data-file-name="components/features-section.tsx">
            Everything you need to transform complex business analysis into winning strategies
          </span></p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-unique-id="2132308f-e561-4160-b49e-1c8bf04aeb0c" data-file-name="components/features-section.tsx" data-dynamic-text="true">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} viewport={{
          once: true
        }} className="card-hover bg-white rounded-2xl p-8 border border-border shadow-lg" data-unique-id="24b52246-2dde-4672-989a-08060e78310e" data-file-name="components/features-section.tsx">
              <div className="space-y-6" data-unique-id="aa0e7d4e-5f7b-408f-b559-5b86028a3021" data-file-name="components/features-section.tsx">
                <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${feature.color} flex items-center justify-center`} data-unique-id="d7d006f0-b0dd-4496-9685-36c60d01bce1" data-file-name="components/features-section.tsx">
                  <feature.icon className="w-8 h-8 text-white" data-unique-id="6d29b454-18e3-4cae-904e-3a6d4bb8c800" data-file-name="components/features-section.tsx" data-dynamic-text="true" />
                </div>
                
                <div className="space-y-3" data-unique-id="0da7e612-7069-4839-b647-cdbcd61fcb41" data-file-name="components/features-section.tsx">
                  <h3 className="text-xl font-semibold" data-unique-id="affa4fd5-21d1-4212-a85a-9457cadfd452" data-file-name="components/features-section.tsx" data-dynamic-text="true">{feature.title}</h3>
                  <p className="text-muted-foreground leading-relaxed" data-unique-id="b46ae61b-2e77-41a9-ac24-8230dece6cc2" data-file-name="components/features-section.tsx" data-dynamic-text="true">
                    {feature.description}
                  </p>
                </div>

                <div className="pt-4" data-unique-id="a4f1d1c9-62d8-4762-9c56-d0994df8c57c" data-file-name="components/features-section.tsx">
                  <button className="text-primary font-semibold hover:text-primary-dark transition-colors inline-flex items-center gap-2 group" data-unique-id="38176cb8-70f7-44aa-8dd0-1fcc3bf5c1ee" data-file-name="components/features-section.tsx"><span className="editable-text" data-unique-id="53a4249b-8f58-4e8a-8e9f-3db594d13d40" data-file-name="components/features-section.tsx">
                    Learn more
                    </span><motion.span className="inline-block" whileHover={{
                  x: 5
                }} transition={{
                  type: "spring",
                  stiffness: 400,
                  damping: 10
                }} data-unique-id="503feafe-3512-4e7c-902e-1cfecaa264b9" data-file-name="components/features-section.tsx"><span className="editable-text" data-unique-id="225c9286-43cc-4c35-823b-e3fc8db0a73a" data-file-name="components/features-section.tsx">
                      →
                    </span></motion.span>
                  </button>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}